<template>
  <div class="content">
    <div class="title">
      <div v-for="item in list" :key="item" class="tab-box" @click="getDetail(item)" @mouseenter="changeTarget(item)" :style="
            target === item
              ? 'color: #000000; border-bottom: 2px solid rgba(203, 180, 134, 1);'
              : ''
          ">
        <span>{{ item }}</span>
      </div>
    </div>
    <div class="box">
      <wycx v-if='target == "我要查询"' />
      <!-- <qzbl v-if='target == "签证办理预约"' /> -->
      <!-- <bljd v-if='target == "办理进度查询"' /> -->
    </div>
  </div>
</template>

<script>
import wycx from "./components/content-01";
import qzbl from "./components/content-02";
import bljd from "./components/content-03";
export default {
  name: 'makeAppointment', //我要预约
  components: {
    qzbl,
    wycx,
    bljd
  },
  data () {
    return {
      list: ['我要查询'],
      target: '我要查询'
    }
  },
  methods: {
    changeTarget (item) {

    },
    getDetail (item) {
      this.target = item;
    }
  }
}
</script>

<style scoped lang='less'>
.title {
  font-size: 25px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  color: rgb(198, 200, 199);
}
.tab-box {
  margin: 10px 20px;
  // border-bottom: 2px solid rgb(203, 180, 134);
}
.tab-box:hover {
  cursor: pointer;
}

.box {
  margin: 10px auto;
  padding: 20px 40px;
  width: 1140px;
  border: 1px solid rgb(229, 229, 229);
}
</style>



// WEBPACK FOOTER //
// src/components/home/query/siderContent-01.vue